var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.509766,
    y: 0.5,
    width: 37,
    height: 37,
    rx: 1.5,
    fill: "#FCFDFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_360_11592)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5098 28H24.3105V21.67C24.3105 20.0157 23.6535 18.885 22.209 18.885C21.1038 18.885 20.4897 19.6475 20.2037 20.3839C20.0973 20.6477 20.1138 21.0145 20.1138 21.3828V28H15.9525C15.9525 28 16.0068 16.7894 15.9525 15.771H20.1138V17.6903C20.3581 16.852 21.6874 15.6547 23.8105 15.6547C26.4425 15.6547 28.5098 17.4122 28.5098 21.2012V28ZM11.7455 14.2422H11.7189C10.3782 14.2422 9.50977 13.3073 9.50977 12.1217C9.50977 10.914 10.4061 10 11.7721 10C13.138 10 13.9774 10.914 14.0053 12.1204C14.0053 13.3047 13.138 14.2422 11.7455 14.2422ZM13.6919 28H9.98751V15.7711H13.6919V28Z",
    fill: "#005A42"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.509766,
    y: 0.5,
    width: 37,
    height: 37,
    rx: 1.5,
    stroke: "#C6C8C8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_360_11592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18,
    fill: "white",
    transform: "translate(9.50977 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1ae60017eff3b28ab7e4378d67a4ddac.svg";
export { ForwardRef as ReactComponent };